export const surveysConstants = {
    SURVEYS_REQUEST: 'SURVEYS_REQUEST',
    SURVEYS_SUCCESS: 'SURVEYS_SUCCESS',
    SURVEYS_ERROR: 'SURVEYS_ERROR',
};

export const VIEW_TYPE = {
    EDIT: 0,
    VIEW: 1,
};

export const Tab = {
    General: 0,
    Questions: 1,
    Customization: 2,
};

export const SystemFieldType = {
    EMAIL: 0,
    PHONE: 1,
    NAME: 2,
};
